import { EngagementBuyerActionState } from '../models/engagement-buyer-action-state.model';
import { TimelineAction } from '../models/timeline-actions.model';
import { TimelineEvent } from '../models/timeline-event.model';
import { DateTimeHelper } from '../../../../utils/dateTimeHelper';

// #1655: a buyer's per-step facts travel on the action of the timeline served to them (the buyer*
// fields of TimelineActionContract) — on their own timeline, and while the serving switch is off on
// the main read for that buyer. These adapters present them in the actionState[] shape the buyer-side
// screens were written against, so the screens stop reading buyer.actionState[] without changing logic.
export const buyerActionFactsOf = (
    action: TimelineAction | null | undefined
): EngagementBuyerActionState | null =>
    action && action.buyerStatus != null
        ? {
              actionId: action.id,
              buyerStatus: action.buyerStatus,
              status: action.buyerActionStatus,
              minPrice: action.minPrice,
              maxPrice: action.maxPrice,
              documentDetailsId: action.documentDetailsId,
              loiFormId: action.loiFormId,
              dateCreated: action.buyerStateCreatedAtUtc
                  ? DateTimeHelper.parseUtc(action.buyerStateCreatedAtUtc)
                  : undefined,
              dateModified: action.buyerStateModifiedAtUtc
                  ? DateTimeHelper.parseUtc(action.buyerStateModifiedAtUtc)
                  : undefined,
          }
        : null;

export const buyerActionFactsFor = (
    events: TimelineEvent[] | null | undefined,
    actionId: number | null | undefined
): EngagementBuyerActionState | null =>
    actionId == null
        ? null
        : buyerActionFactsOf(
              events?.find((e) => e.linkedAction?.id === actionId)?.linkedAction
          );

export const allBuyerActionFacts = (
    events: TimelineEvent[] | null | undefined
): EngagementBuyerActionState[] =>
    (events ?? [])
        .map((e) => buyerActionFactsOf(e.linkedAction))
        .filter((facts): facts is EngagementBuyerActionState => facts != null);
